<template>
  <v-dialog
    :model-value="dialogVisible"
    content-class="align-self-start access-denied-dialog-content"
    width="600px"
    max-width="90%"
    :persistent="!shouldShowCloseButton"
    @click:outside="shouldShowCloseButton ? dialogVisible = false : null"
  >
    <v-card class="p-relative rounded-0">
      <h1 class="py-2 px-5 text-error">
        Access denied
      </h1>
      <v-card-text>
        <div class="text-body-medium pt-4 font-weight-medium">
          You do not have sufficient rights to access this part of Thunderstock.<br>Contact your admin user to gain more rights.
        </div>
        <div
          v-if="accessDeniedDialogContent"
          class="text-body-medium pt-4 font-weight-medium"
        >
          {{ accessDeniedDialogContent }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-row class="dialog-footer text-right py-2">
          <v-col>
            <v-btn
              v-if="shouldShowCloseButton"
              variant="outlined"
              class="text-error mx-4"
              @click="dialogVisible = false"
            >
              Close
            </v-btn>
            <v-btn
              variant="flat"
              color="primary"
              class="mx-4"
              @click="goToHome"
            >
              Go to Home
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useGeneralStore } from '@/store/pinia/generalStore'
import { mapState } from 'pinia'
import { canAccessModule } from '@/auth/ToolkitsAccess'
import { getPageKeyFromRoute, isSuperuser } from '@/auth/ToolkitHelpers'

export default {
  computed: {
    ...mapState(useGeneralStore, ['accessDeniedDialogVisible', 'currentModule', 'accessDeniedDialogContent']),
    dialogVisible: {
      get () {
        return this.accessDeniedDialogVisible
      },
      set (val) {
        useGeneralStore().setAccessDeniedDialogVisible(val)
      }
    },
    currentPage () {
      return getPageKeyFromRoute(this.$route.name || '')
    },
    hasToolkitRestrictions () {
      const generalStore = useGeneralStore()
      return !generalStore.canAccessPage(this.currentModule, this.currentPage)
    },
    shouldShowCloseButton () {
      return !this.hasToolkitRestrictions || isSuperuser()
    }
  },
  methods: {
    goToHome: async function () {
      this.dialogVisible = false
      if (await canAccessModule(this.currentModule) && this.currentModule) {
        if(this.currentModule === 'buy') {
          this.$router.push({path: '/buy/shopping'})
        }else {
          this.$router.push({path: `/${this.currentModule}/home`})
        }
      } else {
        this.$router.push({ path: '/stock/home' })
      }
    },
  }
}
</script>

<style lang="scss">
.access-denied-dialog-content {
    margin-top: 80px;
}
</style>
